import { useContext, useEffect } from 'react'
import { NavigationContext } from '../../context/NavigationContext'
import Button from '../Button/Button'
import PropTypes from 'prop-types'

const CookiePlaceholder = ({ placeholderWrapperRef, modifiers }) => {
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    // This adds a wrapper class to the placeholder's parent element, so that it can be positioned on top.
    placeholderWrapperRef?.current?.classList.add('CookiePlaceholder-wrapper')
  }, [placeholderWrapperRef])

  return !navigationContext.hasConsent('youtube') ? (
    <div className={`CookiePlaceholder ${modifiers ? modifiers.join(' ') : ''}`}>
      <div className="CookiePlaceholder-inner">
        <div className="CookiePlaceholder-icon"></div>
        <div className="CookiePlaceholder-copy">
          <p className="CookiePlaceholder-description">Dit onderdeel gebruikt cookies</p>
        </div>
        <div className="CookiePlaceholder-buttongroup">
          <Button
            modifiers={['Button--cookiePlaceholderConfirm']}
            onClick={navigationContext.acceptAllCookies}
            label="Alle cookies toestaan"
          />
          {navigationContext.consentManagerLoaded && (
            <Button
              modifiers={['Button--cookiePlaceholderInfo']}
              onClick={navigationContext.openCookieSettings}
              label="Informatie &amp; instellingen"
            />
          )}
        </div>
      </div>
    </div>
  ) : null
}

CookiePlaceholder.propTypes = {
  placeholderWrapperRef: PropTypes.object,
  modifiers: PropTypes.arrayOf(PropTypes.string)
}

export default CookiePlaceholder
